// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"57cb124d","264":"3a9bf1ec","480":"55dd2621","488":"8c7f3cc8"}[chunkId] + ".chunk.js";
};